//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Paper, Skeleton } from '@backmarket/design-system'

import translations from './Card.translations'

export default {
  components: {
    Paper,
    Skeleton,
  },
  computed: {
    translations: () => translations,
  },
}
